// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"08ba2211","453":"04b741d9","459":"52fb880b","487":"6ad779f1","547":"fd806c6b","809":"b79b6b6d","987":"cbbbcf16","989":"bceea58f"}[chunkId] + ".chunk.js";
};